import { Component } from '@angular/core';

@Component({
  selector: 'export-collapsible',
  templateUrl: './template.html',
  styleUrls: ['./style.scss'],
})
export class ExportCollapsibleComponent {
  isOpen = true;

  toggle() {
    this.isOpen = !this.isOpen;
  }
}
